import { EPageContainer, EPageType } from '../types/page';

export const PAGE_TYPE_TO_CONTAINER: { [key in EPageType]: EPageContainer } = {
  [EPageType.Authorization]: EPageContainer.Authentication,
  [EPageType.Registration]: EPageContainer.Authentication,
  [EPageType.NewPassword]: EPageContainer.NewPassword,
  [EPageType.SocialLogin]: EPageContainer.SocialLogin,
};
